import AbstractRequestTask from "../../../requests/tasks/AbstractRequestTask";


class MundialRequestTask  extends AbstractRequestTask {
  apiKey: string;
  language: string;
  leagueId: string;

  constructor() {
    super();
    this.apiKey = "y368pewmkbqewyaha8xydgc5";
    this.language = "es-ES";
    this.leagueId = "GNA5MGHG2ZVX2RD";
  }

  getBaseUrl() {
    return `${window.location.protocol || "http:"}//gracenoteclaro.akamaized.net/gsd/lookup/v1`;
  }

  getParams() {
    return {
      api_key: this.apiKey,
      language: this.language
    };
  }

  isValid(data: any): boolean {
      return true;
  }

  success(data: any, b: any) {
    return data;
  }

  getShowErrorModal(){
    return false;
  }

  getMethod() {
    return 'GET';
  }
  getIsByHttps(): boolean {
      return true;
  }
}

export default MundialRequestTask;



// WEBPACK FOOTER //
// ./src/mundial/requests/tasks/MundialRequestTask.ts